import { SET_HELPLY_COPILOT_OPEN } from 'constants/action_types'

export function doSetHelplyCopilotOpen(isOpen) {
  return {
    type: SET_HELPLY_COPILOT_OPEN,
    payload: { isOpen },
  }
}
